import React from "react";
import PropTypes from 'prop-types';
import { Row, Col } from "antd";
import { FeeHeadWrap, ContentWrapMain, ButtonWrap, FeeTable } from "./styles";
import { ContentWrap } from "./../../Components/ShowMoreTotalAdminFee/styles.js";
import { FeeHead, FlexDiv } from "./../../Components/Fee&Expenses/styles.js";
import { getpwUrl } from "../../../../utils/commonUtil";
import { TdValue, TdHeading } from "./../CardComponent/styles.js";
import CardComponent from "./../CardComponent/CardComponent.js";
import { GeneralButton } from './../../../../CommonComponents/Commons/commonComponents';

class ShowMoreAdminFee extends React.Component {
  state = {
    mData: []
  }

  componentDidMount() {
    let mData = [];
    if (this.props.field_table) {
      mData = [{
        data: document.querySelector("#table-txn-fees td:nth-child(1)").textContent,
        type: 'avgInvestfee'
      },
      {
        data: [
          {
            accBalrange: [
              document.querySelector("#table-txn-fees tr:nth-child(1) td:nth-child(3)").textContent,
              document.querySelector("#table-txn-fees tr:nth-child(2) td:nth-child(3)").textContent,
              document.querySelector("#table-txn-fees tr:nth-child(3) td:nth-child(3)").textContent,
            ]
          },
          {
            tieAdminFee: [
              document.querySelector("#table-txn-fees tr:nth-child(1) td:nth-child(4)").textContent,
              document.querySelector("#table-txn-fees tr:nth-child(2) td:nth-child(4)").textContent,
              document.querySelector("#table-txn-fees tr:nth-child(3) td:nth-child(4)").textContent,
            ]
          }
        ],
        type: 'balrange'
      },
      {
        data: document.querySelector("#table-txn-fees td:nth-child(6)").textContent,
        type: 'allIn'
      }]
    };
    this.setState({ mData })
  };

  renderTitleGrid = (data) => {
    let renderArray = [];
    switch (data.type) {
      case 'avgInvestfee':
        renderArray.push(
          <div className="mt-10">
            <TdHeading>Average investment fee</TdHeading>
            <TdValue>{data.data}</TdValue>
          </div>
        )
        break;
      case 'balrange':
        renderArray.push(
          <div>
            <TdHeading>+</TdHeading>
            <FlexDiv>
              <div>
                <TdHeading mPaddingRight='10px'>Account balance range</TdHeading>
                <TdValue>
                  {
                    (() => {
                      let arrayDiv = [];
                      if (data.data[0].accBalrange.length > 0) {
                        data.data[0].accBalrange.map((val) => {
                          arrayDiv.push(
                            <TdValue>{val}</TdValue>
                          )
                        })
                      }
                      return arrayDiv;
                    })()
                  }
                </TdValue>
              </div>
              <div>
                <TdHeading>Tiered administrative fee</TdHeading>
                {
                  (() => {
                    let arrayDiv = [];
                    if (data.data[1].tieAdminFee.length > 0) {
                      data.data[1].tieAdminFee.map((val) => {
                        arrayDiv.push(
                          <TdValue>{val}</TdValue>
                        )
                      })
                    }
                    return arrayDiv;
                  })()
                }
              </div>
            </FlexDiv>
            <TdHeading>{'='}</TdHeading>
          </div>
        )
        break;
      case 'allIn':
        renderArray.push(
          <div className="mt-10">
            <TdHeading>All-in fee</TdHeading>
            <TdValue>{data.data}</TdValue>
          </div>
        )
        break;
    }
    return renderArray;
  };

  destObj = (each) => {
    return [
      {
        name: "avgInvestfee",
        gridWidth: "100",
        type: "FixGrid",
        render: this.renderTitleGrid(each),
        ptop: false,
        pbottom: false,
        pright: true
      }
    ];
  };

  render() {
    return (
      <div data-test="transaction-show-more-admin-fee">
        <ContentWrapMain marginLeft="0">
          <ContentWrap marginBottom="0" paddingBottom="30px" dangerouslySetInnerHTML={{ __html: this.props.field_desc_admin_fee }}>
          </ContentWrap>
        </ContentWrapMain>
        <Row>
          <Col lg={12} md={16} xs={24}>
            {(this.props.field_admin_fee_table && <FeeTable mDisplayTitle dangerouslySetInnerHTML={{ __html: this.props.field_admin_fee_table }} />)}
          </Col>
        </Row>
        <FeeHeadWrap marginLeft="35px" marginBottom="13px">
          <FeeHead>{this.props.field_title_admin_fee_adjustment}</FeeHead>
        </FeeHeadWrap>
        <ContentWrapMain marginLeft="20px">
          <ContentWrap marginBottom="0" paddingBottom="0" dangerouslySetInnerHTML={{ __html: this.props.field_desc_admin_adjustments }}>
          </ContentWrap>
          <ContentWrap marginBottom="0" paddingBottom="30px">
          </ContentWrap>
        </ContentWrapMain>
        <FeeHeadWrap marginLeft="35px" marginBottom="10px">
          <FeeHead>{this.props.field_title_annual_fee_schedule}</FeeHead>
        </FeeHeadWrap>
        <ContentWrapMain marginLeft="20px">
          <ContentWrap marginBottom="0" paddingBottom="20px" dangerouslySetInnerHTML={{ __html: this.props.field_desc_annual_fee_schedule }}>
          </ContentWrap>
        </ContentWrapMain>

        <Row id={"table-txn-fees"}>
          <Col lg={24} md={24} xs={0}>
            {(this.props.field_table && <FeeTable dangerouslySetInnerHTML={{ __html: this.props.field_table }} />)}
          </Col>
          <Col lg={0} md={0} xs={24}>
            <div className="ml-table-30">
              <CardComponent destObj={this.destObj} data={this.state.mData} />
            </div>
          </Col>
        </Row>

        <FeeHeadWrap marginLeft="35px" marginTop="10px" marginBottom="9px">
          <FeeHead>{this.props.field_title_please_note}</FeeHead>
        </FeeHeadWrap>

        <ContentWrapMain marginLeft="20px">
          <ContentWrap marginBottom="0" paddingBottom="30px" dangerouslySetInnerHTML={{ __html: this.props.field_description_please_note }}>
          </ContentWrap>
        </ContentWrapMain>
        <ButtonWrap>
          <a href={`${getpwUrl()}giving-with-vc/fees-and-minimums`} target="_blank">
            <GeneralButton text="VIEW INVESTMENT FEES" type="secondary" />
          </a>
        </ButtonWrap>

        <FeeHeadWrap marginLeft="35px" marginTop="30px" marginBottom="9px">
          <FeeHead>Footnote</FeeHead>
        </FeeHeadWrap>
        <ContentWrapMain marginLeft="20px">
          <ContentWrap marginBottom="0" paddingBottom="30px" dangerouslySetInnerHTML={{ __html: this.props.field_transaction_footnotes }}>
          </ContentWrap>
        </ContentWrapMain>
      </div>
    );
  }
};

ShowMoreAdminFee.propTypes = {
  field_admin_fee_table: PropTypes.string,
  field_desc_admin_adjustments: PropTypes.string,
  field_desc_admin_fee: PropTypes.string,
  field_desc_annual_fee_schedule: PropTypes.string,
  field_description_please_note: PropTypes.string,
  field_table: PropTypes.string,
  field_title_admin_fee_adjustment: PropTypes.string,
  field_title_annual_fee_schedule: PropTypes.string,
  field_title_please_note: PropTypes.string,
  field_transaction_footnotes: PropTypes.string,
}

export default ShowMoreAdminFee;
